import {Base} from "@/api/Base"

export class LogAdd extends Base {
    path = "log/add"
}